import { addCustomRate, createCompany, createStripeCreditCard, createStripeCustomer, deleteCustomRate, editCompany,
  editCompanyDepartmentById, getCompanies, getCompaniesByName, getCompanyDepartmentsById, getCompanyDetails, getCompanyPayment,
  getCompanyPaymentByEmployer, deleteCompanyPayment, getContactsByCompanyId, getStripePublicKey, postCompanyDepartment,
  getLTAWorkers, addLTAWorker, removeLTAWorker, getCompanyInfoByEmployer, getFavAndBlocks, createFavBlockWorker,
  updateFavBlockWorker, deleteFavBlockWorker } from '../api';
import { dispatchErrorAction } from './index';
import * as actionTypes from './actionTypes';
import { COMPANIES_LIST_PAGE_SIZE } from '../constants/general';
import { getPagesCount, setStripeCardData } from '../helpers/general';
import UsersService from '../services/UsersService';

export function getAllCompanies (skip = 0, filterData) {
  return dispatch => getCompanies(skip, filterData)
    .then(({ data }) => {
      const pagesQuantity = getPagesCount(data.count, COMPANIES_LIST_PAGE_SIZE);
      dispatch({ type: actionTypes.GET_ALL_COMPANIES_SUCCESS, companiesList: data.data, pagesQuantity });
      return ({ data, pagesQuantity });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function createNewCompany (payload) {
  return dispatch => createCompany(payload)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function getCompanyDetailsAction (id = null) {
  const getCompanyMethod = UsersService.isAdmin() ? getCompanyDetails : getCompanyInfoByEmployer;

  return dispatch => getCompanyMethod(id)
    .then(({ data }) => {
      dispatch({ type: actionTypes.GET_COMPANY_DETAILS_SUCCESS, companyDetails: data });
      return data;
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function editCompanyAction (id, payload) {
  return dispatch => editCompany(id, payload)
    .then(({ data }) => dispatch({ type: actionTypes.EDIT_COMPANY_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function addCustomRateAction (data) {
  return dispatch => addCustomRate(data)
    .then(({ data }) => dispatch({ type: actionTypes.ADD_CUSTOM_RATE_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function deleteCustomRateAction (id) {
  return dispatch => deleteCustomRate(id)
    .then(() => dispatch({ type: actionTypes.DELETE_CUSTOM_RATE_SUCCESS, data: id }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {number} id
 * */
export function getCompanyDepartments (id) {
  return dispatch => getCompanyDepartmentsById(id)
    .then(({ data }) => dispatch({ type: actionTypes.GET_COMPANY_DEPARTMENTS_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {number} id
 * @param {object} payload
 * */
export function editCompanyDepartment (id, payload) {
  return (dispatch, getState) => editCompanyDepartmentById(id, payload)
    .then(({ data }) => {
      const departments = getState().companies.companyDetails.departments.map(dept => {
        if (dept.id === id) {
          return data;
        }
        return dept;
      });

      return dispatch({ type: actionTypes.GET_COMPANY_DEPARTMENTS_SUCCESS, data: departments });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {object} data
 * @param {number} data.company_id
 * @param {string} data.name
 * */
export function createCompanyDepartment (data) {
  return (dispatch, getState) => postCompanyDepartment(data)
    .then(({ data }) => dispatch({
      type: actionTypes.GET_COMPANY_DEPARTMENTS_SUCCESS,
      data: [...getState().companies.companyDetails.departments, data]
    }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {number} company_id
 * */
export function getCompanyContacts (company_id) {
  return dispatch => getContactsByCompanyId(company_id)
    .then(({ data }) => dispatch({ type: actionTypes.GET_COMPANY_CONTACTS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {string} name
 * */
export function searchCompaniesByName (name) {
  return dispatch => getCompaniesByName(name)
    .then(({ data }) => dispatch({ type: actionTypes.SEARCH_COMPANIES_BY_NAME_SUCCESS, data: data.data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function clearCompaniesSearchByNameResults () {
  return dispatch => dispatch({ type: actionTypes.SEARCH_COMPANIES_BY_NAME_CLEAR_RESULTS });
}

export function getCompanyPaymentAction (company_id = null) {
  const getCompanyPaymentMethod = UsersService.isAdmin() ? getCompanyPayment : getCompanyPaymentByEmployer;
  return dispatch => getCompanyPaymentMethod(company_id)
    .then(({ data }) => {
      if (data) {
        const payment = data.find(payment => payment.is_default);
        dispatch({ type: actionTypes.GET_COMPANY_PAYMENT_SUCCESS, data: payment || null });
      }
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function deletePaymentInfo (company_id) {
  return dispatch => deleteCompanyPayment(company_id)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function clearCompanyDetailsAction () {
  return dispatch => dispatch({ type: actionTypes.CLEAR_COMPANY_DETAILS });
}

/**
 *
 * Stripe
 *
 * */

export function createStripeCustomerWithCard (company_id, formData) {
  return async dispatch => {
    const { data: stripePublicKey } = await getStripePublicKey();
    return createStripeCreditCard(setStripeCardData(formData), stripePublicKey)
      .then(({ data: { id: stripe_token } }) => {
        return createStripeCustomer(company_id, stripe_token)
          .then(({ data }) => {
            dispatch({ type: actionTypes.GET_COMPANY_PAYMENT_SUCCESS, data });
            return data;
          })
          .catch(error => dispatchErrorAction(error, dispatch));
      })
      .catch(error => dispatchErrorAction(error, dispatch));
  };
}

/**
 * @param {number} company_id
 * @param {number} [job_skill_id]
 * */
export function getCompanyLTAWorkers (company_id, job_skill_id) {
  return dispatch => getLTAWorkers(company_id, job_skill_id)
    .then(({ data }) => dispatch({ type: actionTypes.GET_LTA_WORKERS_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function clearCompanyLTAWorkers () {
  return dispatch => dispatch({ type: actionTypes.CLEAR_LTA_WORKERS });
}

/**
 * @param {number} user_id
 * @param {number} company_id
 * */
export function addCompanyLTAWorker (user_id, company_id) {
  return () => addLTAWorker(user_id, company_id)
    .then(({ data }) => data)
    .catch(error => error.response.data);
}

/**
 * @param {number} worker_id
 * */
export function removeCompanyLTAWorker (worker_id) {
  return dispatch => removeLTAWorker(worker_id)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {object} [payload: {[company_id], [status], [skill], [job_id], [job_date]}]
 */
export function getCompanyFavAndBlocks (payload) {
  return dispatch => getFavAndBlocks(payload)
    .then(({ data }) => dispatch({ type: actionTypes.GET_FAV_AND_BLOCKS_SUCCESS, count: data.count, data: data.data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function clearCompanyFavAndBlocks () {
  return dispatch => dispatch({ type: actionTypes.CLEAR_FAV_AND_BLOCKS });
}

/**
 * @param {object} data
 */
export function createCompanyWorker (data) {
  return dispatch => createFavBlockWorker(data)
    .then(({ data }) => dispatch({ type: actionTypes.POST_FAV_BLOCK_WORKER_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {number} id
 * @param {object} data
 */
export function updateCompanyWorker (id, data) {
  return dispatch => updateFavBlockWorker(id, data)
    .then(({ data }) => dispatch({ type: actionTypes.PUT_FAV_BLOCK_WORKER_SUCCESS, data }))
    .catch(error => dispatchErrorAction(error, dispatch));
}

/**
 * @param {number} id
 */
export function deleteCompanyWorker (id) {
  return dispatch => deleteFavBlockWorker(id)
    .then(() => dispatch({ type: actionTypes.DELETE_FAV_BLOCK_WORKER_SUCCESS, data: { id } }))
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/companies.js